import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      height: 'auto',
      borderRadius: 4,

      '&:hover': {
        backgroundColor: COLORS.gray.gray90,
      },
    },
    selected: {
      backgroundColor: COLORS.primary.light,
    },
  }),
  { name: 'FieldSelectMenuItem' }
);
